module.exports = __webpack_public_path__ + "img/02.36277379.png";